import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const templateRenderingApi = {
  getFields: async (scope, specificScope) => {
    const params = new URLSearchParams();
    if (scope) params.append('scope', scope);
    if (specificScope) params.append('specificScope', specificScope);
    const res = await fetch(
      `${config.api.url}/templates/fields?${params.toString()}`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },

  getPrenatalContext: async (pregnancyReferenceId, visitId) => {
    const params = new URLSearchParams();
    if (pregnancyReferenceId) params.append('pregnancyReferenceId', pregnancyReferenceId);
    if (visitId != null) params.append('visitId', visitId);
    const res = await fetch(
      `${config.api.url}/templates/context/prenatal?${params.toString()}`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },

  getPostpartumContext: async (pregnancyReferenceId, visitId) => {
    const params = new URLSearchParams();
    if (pregnancyReferenceId) params.append('pregnancyReferenceId', pregnancyReferenceId);
    if (visitId != null) params.append('visitId', visitId);
    const res = await fetch(
      `${config.api.url}/templates/context/postpartum?${params.toString()}`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },

  getNewbornContext: async (pregnancyReferenceId, visitId) => {
    const params = new URLSearchParams();
    if (pregnancyReferenceId) params.append('pregnancyReferenceId', pregnancyReferenceId);
    if (visitId != null) params.append('visitId', visitId);
    const res = await fetch(
      `${config.api.url}/templates/context/newborn?${params.toString()}`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },

  getBirthEventContext: async (pregnancyReferenceId, referenceId, laborRecordId) => {
    const params = new URLSearchParams();
    if (pregnancyReferenceId) params.append('pregnancyReferenceId', pregnancyReferenceId);
    if (referenceId) params.append('referenceId', referenceId);
    if (laborRecordId != null) params.append('laborRecordId', laborRecordId);
    const res = await fetch(
      `${config.api.url}/templates/context/birth-event?${params.toString()}`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },

  renderTemplate: async (payload) => {
    const res = await fetch(
      `${config.api.url}/templates/render`,
      {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      }
    );
    return handleResponse(res);
  },
};

export default templateRenderingApi;
